import React, { useMemo, useEffect } from 'react';
import { UseSelector, useDispatch, useSelector } from 'react-redux';
import TableContainer from 'Common/TableContainer';
import CountUp from 'react-countup';
import { Package, PackageX, Truck, Wallet2 } from 'lucide-react';
import { Search, Plus, Trash2, Pencil, Check, FileBarChart2, CalendarCheck, Codepen, Loader } from 'lucide-react';
import { RootState } from 'slices';
import { getMainAccount, getgoldsoldvalue, getGoldWeigth, getOutstanding, getProfit, viewDashbord } from 'slices/thunk'



interface Props {
    manager: any[];
    account: any[]
}

const ManagerDetails: React.FC<Props> = ({ manager, account }) => {
    const dispatch = useDispatch()
    const mainAccount = useSelector((state: RootState) => state.Ecommerce.account)
    const goldSold = useSelector((state: RootState) => state.Ecommerce.goldSold)
    const goldWeigth = useSelector((state: RootState) => state.Ecommerce.goldWeigth)
    const goldOutstanding = useSelector((state: RootState) => state.Ecommerce.goldOutstanding)
    const profit = useSelector((state: RootState) => state.Settings.profit)

    const dashbord = useSelector((state: RootState) => state.Settings.dashbord)

    useEffect(() => {
        dispatch(getMainAccount() as any)
        dispatch(getgoldsoldvalue() as any)
        dispatch(getGoldWeigth() as any)
        dispatch(getOutstanding() as any)
        dispatch(getProfit() as any)
        dispatch(viewDashbord() as any)
    }, [dispatch])

    console.log(dashbord)
    const columns = useMemo(() => [
        {
            header: "#",
            accessorFn: (_: any, index: number) => index + 1,
            enableColumnFilter: false,
        },
        {
            header: "Username",
            accessorKey: "username",
            enableColumnFilter: false,
        },
        {
            header: "Mobile",
            accessorKey: "mobile",
            enableColumnFilter: false,
        },
        {
            header: "Country",
            accessorKey: "country",
            enableColumnFilter: false,
        },
        {
            header: "Amount",
            accessorFn: (row: any) => {
                const acc = account.find((a: any) => a.managerId === row._id);
                return acc?.amount ?? 0;
            },
            enableColumnFilter: false,
        },

    ], [manager, account]);


    return (
        <div className=" col-span-9   ">
            <div className="relative col-span-8 ">
                <div className="grid items-center grid-cols-8 space-x-2    ">
                    <div className="  card  col-span-2 flex items-center justify-center  ">
                        <div className="text-center card-body ">
                            <div className="flex items-center justify-center mx-auto rounded-full size-14 bg-custom-100 text-custom-500 dark:bg-custom-500/20">
                                <Package />
                            </div>
                            <h5 className="mt-4 mb-2">
                                <CountUp end={dashbord?.stokesdData} decimals={1} className="counter-value " /> <span className='text-[0.8vw]'>/Gm &nbsp;</span>
                                {/* <span className='text-[0.8vw]'>Aed &nbsp;</span> */}
                            </h5>
                            <p className="text-slate-500 dark:text-zink-200">Total Stock </p>
                        </div>
                    </div>
                    <div className="card  col-span-2  flex items-center justify-center">
                        <div className="text-center card-body">
                            <div className="flex items-center justify-center mx-auto text-purple-500 bg-purple-100 rounded-full size-14 dark:bg-purple-500/20">
                                <Wallet2 />
                            </div>
                            <h5 className="mt-4 mb-2"><CountUp end={dashbord?.salesData} className="counter-value" /> <span className='text-[0.8vw]'>Aed &nbsp;</span> </h5>
                            <p className="text-slate-500 dark:text-zink-200">Total Sales</p>
                        </div>
                    </div>
                    <div className="card  col-span-2  flex items-center justify-center">
                        <div className="text-center card-body">
                            <div className="flex items-center justify-center mx-auto text-red-500 bg-red-100 rounded-full size-14 dark:bg-red-500/20">
                                <Truck />
                            </div>
                            <h5 className="mt-4 mb-2"><CountUp end={dashbord?.purchaseData} className="counter-value" /> <span className='text-[0.8vw]'>Aed &nbsp;</span></h5>
                            <p className="text-slate-500 dark:text-zink-200">Total Purchase</p>
                        </div>
                    </div>
                    <div className="card  col-span-2  flex items-center justify-center">
                        <div className="text-center card-body">
                            <div className="flex items-center justify-center mx-auto text-green-500 bg-green-100 rounded-full size-14 dark:bg-green-500/20">
                                <PackageX />
                            </div>
                            <h5 className="mt-4 mb-2"><CountUp end={dashbord?.expenseData} className="counter-value" /><span className='text-[0.8vw] ml-2'>Aed &nbsp;</span></h5>
                            <p className="text-slate-500 dark:text-zink-200">Total Expense </p>
                        </div>
                    </div>

                </div>
            </div>
            <div className=" col-span-9 card h-[350px] ">
                <div className="card-body">
                    <div className="grid items-center grid-cols-9 gap-3   ">
                        <div className=" col-span-5  ">
                            <h6 className="text-15">Manager List in <span className='uppercase'>{manager[0]?.country}</span></h6>
                        </div>
                        <div className=" col-span-1 col-start-10   mb-2 ">
                            <button type="button" className="btn bg-custom-500 text-white">
                                <i className="ri-download-2-line pr-1"></i> Export
                            </button>
                        </div>
                    </div>
                    <TableContainer
                        isPagination={true}
                        columns={columns}
                        data={manager || []}
                        customPageSize={4}
                        divclassName="overflow-x-auto"
                        tableclassName="w-full whitespace-nowrap"
                        theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                        thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                        tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                        PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
                    />
                </div>
            </div>
        </div>
    );
};

export default ManagerDetails;

